var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-header',[_c('h4',{staticClass:"title"},[_vm._v(" نقش‌ها و دسترسی‌ها ")])]),_c('b-card-body',[_c('managed-in-dash-notice')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }